import React from "react";

type DashboardCardProps = {
  children: React.ReactNode;
  className?: string;
};

const DashboardCard = ({ children, className = "" }: DashboardCardProps) => {
  return (
    <section className={`rounded-[8px] border border-light-grey bg-white ${className}`}>
      {children}
    </section>
  );
};

export default DashboardCard;

